<template>
  <div id="home_view">

    <div class="thumbnail_box">
      <div class="thumbnail_mask"></div>
        <img src="@/assets/home_thumbnail.jpeg" alt="" class="home_thumbnail">
      <div class="headline">
          <div class="title tracking-in-expand">{{ $t("home.HOME_TITLE") }}</div>
          <div class="sub_title">{{ $t("home.HOME_SUB_TITLE") }}</div>
          <div class="sub_title">{{ $t("home.HOME_SUB_TITLE_DOWN") }}</div>
      </div>
      <div class="indictor">
        <van-icon name="arrow-down" color="#fff" size="3rem" class="arrow" />
      </div>
    </div>

    <div class="main">
      <StatisticsView />
      <ExporeMore />
      <PastProjects />
    </div>
  </div>
</template>

<script setup lang="ts">
import StatisticsView from "./StatisticsView.vue";
import ExporeMore from "./ExporeMore.vue";
import PastProjects from "./PastProjects.vue";
import { onActivated, } from "vue";



onActivated(() => {
  window.scrollTo({ top: 0 });
});
</script>

<style lang="less" scoped>
#home_view {
  overflow: hidden;

  @keyframes modeY {
    0% {
      transform: translateY(0) translateX(-50%);
      opacity: 0.2;
    }
    50% {
      transform: translateY(20px) translateX(-50%);
      opacity: 1;
    }
    100% {
      transform: translateY(0) translateX(-50%);
      opacity: 0.2;
    }
  }

  @-webkit-keyframes tracking-in-expand {
    0% {
      letter-spacing: -0.5em;
      opacity: 0;
    }
    40% {
      opacity: 0.6;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes tracking-in-expand {
    0% {
      letter-spacing: -0.5em;
      opacity: 0;
    }
    40% {
      opacity: 0.6;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }


  .thumbnail_box {
    height: 100vh;
    width: 100%;
    position: relative;
    background-size: cover;
    overflow: hidden;

    .home_thumbnail {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .thumbnail_mask {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      background: rgba(0, 0, 0, 0.3);
    }

    .bg_video {
      position: absolute;
      top: 50%;
      left: 50%;
      min-width: 100%;
      min-height: 100%;
      width: auto;
      height: auto;
      z-index: 1;
      transform: translate(-50%, -50%);
    }

    .indictor {
      position: absolute;
      left: 50%;
      bottom: 2rem;
      animation: modeY 1s infinite;
      z-index: 2;
    }
  }

    .headline {
      width: 100%;
      max-width: var(--view-max-width);
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%,-50%);
      z-index: 3;

      .title {
        font-size: var(--label-title);
        text-align: center;
        line-height: 8rem;  
        animation: tracking-in-expand 1s;
        animation-delay: 0.5s;
        animation-fill-mode: forwards;
        font-family: "HarmonyOS_Bold";
        color: var(--font-color-white-strong);
        text-shadow: 2px 2px 8px rgba(100, 100, 100, 0.5);
        opacity: 0;
      }

      .sub_title {
        color: #f1f1f1;
        font-size: var(--primary-title);
        text-align: center;
        animation: fadeIn 1s;
        animation-fill-mode: forwards;
        animation-delay: 1s;
        opacity: 0;
        overflow-y: hidden;
        line-height: 4rem;
        font-weight: 700;
        margin-bottom: 1rem;
        text-shadow: 2px 2px 8px rgba(100, 100, 100, 0.5);
      }
    }
  }

  .main {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
</style>
